import infoContent from '../text-content/info-content';

export default 
`
<div id="info-center">
    <div id="info-default" class="info-font">
        <h2><span class="info-title">Coagulation Cascade</span></h2>
        <p>The coagulation cascade is a part of secondary hemostasis. The cascade includes an intrinsic pathway and extrinsic pathway which both lead to the common pathway to fibrin formation. The coagulation cascade works like a series of gears—each coagulation factor must activate the next until the clot is formed. If any factor is missing from the coagulation cascade, the clot won’t form correctly.</p>
    </div>

    <div id="info-hemA" class="default-hidden info-font">
        <h2><span class="info-title"> Condition: </span> Hemophilia A, No Inhibitors</h2>
        <p>Hemophilia A is a <strong>bleeding disorder</strong> caused by a missing or defective <strong>factor VIII</strong> clotting protein. Without enough working factor VIII, a strong clot cannot form. People with hemophilia A bleed longer than others and can have bleeds in their joints, muscles, or skin.</p>
    </div>

    <div id="info-hemA-rf" class="default-hidden info-font">
        <h2><span class="info-title">Condition: </span> Hemophilia A
            <br/><span class="info-title">Treatment: </span> Replacement Factor VIII
        </h2>
        <p>People with hemophilia A can infuse
            <strong>replacement factor</strong> VIII into their vein or a port when they have a bleed. By infusing factor VIII, the body can now use it in the
            <strong>intrinsic pathway</strong> to form a strong, durable clot.</p>
    </div>

    <div id="info-hemALow" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia A, Low-titer Inhibitors</h2>
        <p>Some people with hemophilia A can have an allergic reaction to their replacement factor. Their 
            <strong>immune system</strong> thinks that the
            <strong>replacement factor</strong> is a foreign substance and releases 
            <strong>antibodies (inhibitors)</strong> that inactivate replacement factor VIII.</p>
    </div>

    <div id="info-hemALow-rf" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia A, Low-titer Inhibitors
            <br/><span class="info-title">Treatment:</span> High Replacement Factor VIII
        </h2>
        <p>If your body has a weak immune reaction to 
            <strong>replacement factor</strong>, it only releases low amounts of 
            <strong>antibodies</strong> or
            <strong>inhibitors</strong>, called
            <strong>low-titer inhibitors</strong>. If you infuse a high amount of 
            <strong>replacement factor</strong> VIII when you have a bleed, the 
            <strong>antibodies</strong> only bind to some of the replacement factor. The rest of 
            <strong>replacement factor</strong> VIII can be used in the
            <strong>intrinsic pathway</strong> to help form a strong, durable 
            <strong>clot</strong>.
        </p>
    </div>

    <div id="info-hemAHigh" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia A, High-titer Inhibitors</h2>
        <p>If your body has a strong immune reaction to <strong>replacement factor</strong>, it releases a lot of <strong>antibodies</strong> or inhibitors, called
            <strong>high-titer inhibitors</strong>. When antibodies or inhibitors bind to replacement factor VIII, the replacement factor will no longer work in your body the way it should. You may need to use bypassing agents instead when you have a bleed.</p>
    </div>

    <div id="info-hemAHigh-apcc" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia A, High-titer Inhibitors 
            <br/><span class="info-title">Treatment:</span> aPCC
        </h2>
        <p>Activated prothrombin complex concentrate (aPCC) is one of two bypassing agents approved to treat bleeds in someone with a high-titer inhibitor. aPCC contains several different clotting factors in the <strong>coagulation cascade</strong>, bypassing the need for factor VIII. When you treat a bleed with aPCC, these other factors activate the <strong>common pathway</strong> and lead to thrombin production, which then helps your body to form a strong, durable clot.</p>
    </div>

    <div id="info-hemAHigh-fviia" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia A, High-titer Inhibitors
            <br/><span class="info-title">Treatment:</span> FVIIa
        </h2>
        <p>Activated factor VII (FVIIa) is one of two bypassing agents approved to treat bleeds in someone with a high-titer inhibitor. By using FVIIa to treat a bleed, the body can “bypass” the <strong>intrinsic pathway</strong> to clot formation, eliminating the need for FVIII. FVIIa uses the <strong>extrinsic pathway</strong> to activate factor X and start the <strong>common pathway</strong> to a thrombin burst, leading to the formation of a strong, durable clot.</p>
    </div>

    <div id="info-hemB" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B, No Inhibitors</h2>
        <p>Hemophilia B is a <strong>bleeding disorder</strong> caused by a missing or defective <strong>factor IX</strong> clotting protein. People with hemophilia B bleed longer than others and can have bleeds in their joints, muscles, or their skin. Hemophilia B is four times less common than hemophilia A.</p>
    </div>

    <div id="info-hemB-rf" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B
            <br/><span class="info-title">Treatment:</span> Replacement Factor IX
        </h2>
        <p>People with hemophilia B can infuse
            <strong>replacement factor</strong> IX into their vein or a port when they have a bleed. By infusing factor IX, the body can now use it in the <strong>intrinsic pathway</strong> to form a strong, durable clot.</p>
    </div>

    <div id="info-hemBLow" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B, Low-titer inhibitors</h2>
        <p>Some people with hemophilia B can have an allergic reaction to their replacement factor. Their
            <strong>immune system</strong> thinks that the replacement factor is a foreign substance and releases 
            <strong>antibodies (inhibitors)</strong> that inactivate replacement factor IX. </p>
    </div>

    <div id="info-hemBLow-rf" class="default-hidden info-font">
        <h2><span class="info-title">Condition: </span>Hemophilia B, Low-titer inhibitors
            <br/><span class="info-title">Treatment:</span> High Replacement Factor IX
        </h2>
        <p>If your body has a weak immune reaction to <strong>replacement factor</strong>, it only releases low amounts of  <strong>antibodies</strong>
            or <strong>inhibitors</strong>, called
            <strong>low-titer inhibitors</strong>. If you infuse a high amount of 
            <strong>replacement factor</strong> IX when you have a bleed, the 
            <strong>antibodies</strong> only bind to some of the replacement factor. The rest of the <strong>replacement factor</strong> IX can be used in the 
            <strong>intrinsic pathway</strong> to help form a strong, durable 
            <strong>clot</strong>.</p>
    </div>

    <div id="info-hemBHigh" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B, High-titer inhibitors</h2>
        <p>If your body has a strong immune reaction to <strong>replacement factor</strong>, it releases a lot of <strong>antibodies</strong> or <strong>inhibitors</strong>,
            called
            <strong>high-titer inhibitors</strong>. When antibodies or inhibitors bind to replacement factor IX, the replacement factor will no longer work in the body the way it should. You may need to use bypassing agents instead when you have a bleed.</p>
    </div>

    <div id="info-hemBHigh-apcc" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B, High-titer inhibitors
            <br/><span class="info-title">Treatment:</span> aPCC
        </h2>
        <p>Activated prothrombin complex concentrate (aPCC) is one of two bypassing agents approved to treat bleeds in someone with a high-titer inhibitor. aPCC contains several different clotting factors in the <strong>coagulation cascade</strong>, bypassing the need for Factor IX. When you treat a bleed with aPCC, these other factors activate the <strong>common pathway</strong> and lead to thrombin production, which then helps your body to form a strong, durable clot.</p>
    </div>

    <div id="info-hemBHigh-fviia" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> Hemophilia B, High inhibitors
            <br/><span class="info-title">Treatment:</span> FVIIa
        </h2>
        <p>Activated factor VII (FVIIa) is one of two bypassing agents approved to treat bleeds in someone with a high-titer inhibitor. By using FVIIa to treat a bleed, the body can “bypass” the <strong>intrinsic pathway</strong> to clot formation, eliminating the need for Factor IX. FVIIa uses the <strong>extrinsic pathway</strong> to activate factor X and start the <strong>common pathway</strong> to a thrombin burst, leading to the formation of a strong, durable clot.</p>
    </div>

    <div id="info-vWD" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> von Willebrand Disease</h2>
        <p>von Willebrand Disease (vWD) is the most common bleeding disorder, occurring equally in men and women. von Willebrand disease is a genetic disorder caused by a missing or defective von Willebrand factor (vWF), a clotting protein that works with factor VIII to help make platelets stick to the site of injury, forming the <strong>platelet plug</strong>. Some people with vWD also have low levels of factor VIII. There are different levels of severity of vWD, and different ways to treat it, depending on severity. Some people with less severe vWD may not even know that they have it.
        </p>
    </div>

    <div id="info-vWD-desmopressin" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> von Willebrand Disease
            <br/><span class="info-title">Treatment:</span> Desmopressin
        </h2>
        <p>When they have a bleed, some people with von Willebrand disease (vWD) can infuse or inhale desmopressin (DDAVP), which causes the body’s cells to release more von Willebrand factor and FVIII. von Willebrand factor helps to stabilize FVIII levels in the body by protecting factor VIII from being broken down. vWF helps create better <strong>platelet plugs</strong> and strong, durable clots.</p>
    </div>

    <div id="info-vWD-vWFFVIII" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> von Willebrand Disease
            <br/><span class="info-title">Treatment:</span> Replacement vWF+FVIII
        </h2>
        <p>People with von Willebrand disease (vWD) who have lower FVIII levels can infuse factor concentrate containing von Willebrand factor (vWF) and FVIII. vWF helps stabilize FVIII, so that it is not broken down in the body, and helps <strong>platelet plugs</strong> stick to the site of an injury, creating strong, durable clots.</p>
    </div>

    <div id="info-vWD-vWF" class="default-hidden info-font">
        <h2><span class="info-title">Condition:</span> von Willebrand Disease
            <br/><span class="info-title">Treatment:</span> Replacement vWF
        </h2>
        <p>People with von Willebrand disease (vWD) who have adequate FVIII levels can infuse a factor concentrate that contains von Willebrand factor (vWF) only. Infused vWF can help stabilize the level of FVIII in the body by protecting FVIII from being broken down, and help platelets stick to the wound, creating better <strong>platelet plugs</strong> and strong, durable clots.</p>
    </div>

    <div id="info-factor_12" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorXII.title}</span></h2>
        <p>${infoContent.factors.factorXII.description}</p>
    </div>

    <div id="info-factor_11" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorXI.title}</span></h2>
        <p>${infoContent.factors.factorXI.description}</p>
    </div>

    <div id="info-factor_09" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorIX.title}</span></h2>
        <p>${infoContent.factors.factorIX.description}</p>
    </div>

    <div id="info-factor_08" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorVIII.title}</span></h2>
        <p>${infoContent.factors.factorVIII.description}</p>
    </div>

    <div id="info-factor_vW" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.vonWillebrandFactor.title}</span></h2>
        <p>${infoContent.factors.vonWillebrandFactor.description}</p>
    </div>

    <div id="info-factor_10" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorX.title}</span></h2>
        <p>${infoContent.factors.factorX.description}</p>
    </div>

    <div id="info-factor_07a" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorVIIa.title}</span></h2>
        <p>${infoContent.factors.factorVIIa.description}</p>
    </div>

    <div id="info-factor_05a" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorVa.title}</span></h2>
        <p>${infoContent.factors.factorVa.description}</p>
    </div>

    <div id="info-factor_02a" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.thrombin_IIa.title}</span></h2>
        <p>${infoContent.factors.thrombin_IIa.description}</p>
    </div>

    <div id="info-factor_01a" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.fibrin_Ia.title}</span></h2>
        <p>${infoContent.factors.fibrin_Ia.description}</p>
    </div>

    <div id="info-factor_CLOT" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.clot.title}</span></h2>
        <p>${infoContent.factors.clot.description}</p>
    </div>

    <div id="info-factor_13a" class="default-hidden info-font">
        <h2><span class="info-title">${infoContent.factors.factorXIIIa.title}</span></h2>
        <p>${infoContent.factors.factorXIIIa.description}</p>
    </div>

    <div id="info-center_toggle" class="">
        <div></div>    
        <div class="infobox-toggle-btn"></div>
    </div>
    
</div>

            
            

`


// WEBPACK FOOTER //
// ./src/js/html-modules/info-center-html.js